"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowIcon = _interopRequireDefault(require("./ArrowIcon"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
      width: '100%',
      fontSize: 28,
      textTransform: theme.text.textTransformUppercase
    }, theme.breakpoints.down('sm'), {
      justifyContent: 'center'
    }),
    icon: {
      transform: 'rotate(90deg)',
      position: 'absolute',
      right: 20
    },
    iconCollapsed: {
      transform: 'rotate(-90deg)'
    },
    mobile: {
      border: '1px solid',
      borderColor: theme.palette.text.primary,
      borderRadius: 6,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
      position: 'relative'
    },
    mobileCollapsed: {
      background: theme.palette.common.white
    },
    mobileOpen: {
      background: theme.palette.another.tabs
    },
    expandLess: {}
  };
}, {
  name: 'ProductDetailSectionTitle'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_ArrowIcon.default, null);

function ProductDetailSectionTitle(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      collapsed = _ref.collapsed,
      onToggleCollapse = _ref.onToggleCollapse,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "collapsed", "onToggleCollapse"]);
  var classes = useStyles({
    classes: pClasses
  });
  var otherProps = onToggleCollapse ? {
    onClick: onToggleCollapse,
    role: 'button',
    'aria-hidden': 'true'
  } : undefined;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className, onToggleCollapse && [classes.mobile, collapsed ? classes.mobileOpen : classes.mobileCollapsed])
  }, otherProps), children, onToggleCollapse && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: (0, _clsx.default)(classes.icon, onToggleCollapse && collapsed && classes.iconCollapsed)
  }, _ref2));
}

process.env.NODE_ENV !== "production" ? ProductDetailSectionTitle.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    iconCollapsed: _propTypes.default.string,
    mobile: _propTypes.default.string,
    mobileCollapsed: _propTypes.default.string,
    mobileOpen: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  collapsed: _propTypes.default.bool,
  onToggleCollapse: _propTypes.default.bool
} : void 0;
ProductDetailSectionTitle.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  collapsed: false,
  onToggleCollapse: false
};
var _default = ProductDetailSectionTitle;
exports.default = _default;